import React, { useState, useEffect } from "react"

const DynamicImage = (props) => {
    const { alt, className, path, extension } = props
    const [image, setImage] = useState()
    useEffect(() => {
        const loadData = async () => {
            // eslint-disable-next-line prefer-template
            import("@/" + path + "." + extension)
                .then((value) => {
                    setImage(value)
                })
                .catch((error) => {
                    console.log("error", error)
                })
        }
        loadData()
    }, [path, extension])
    return image ? <img src={image.default} alt={alt} className={className} {...props} /> : <></>
}

export default DynamicImage
